export default __webpack_public_path__ + "static/media/LEVEL_UP.f1ebd134.png";